import type { ChatMessage } from '../../Authentication/chat/chat-types';

/**
 * What the Pertento team says beside the "connect your website" page, hardcoded like the
 * signup pitch: it is the standing answer to the questions this page raises, not something
 * a Super Admin edits. It follows what the page and the product really do: every plan has
 * unlimited websites, each subdomain is its own website, and the install is confirmed when
 * the first experiment runs, so nothing here promises a check the app does not make.
 */
export const WEBSITE_TIPS: readonly ChatMessage[] = [
  { kind: 'headline', text: 'First, the website you want to test.' },
  {
    kind: 'text',
    from: 'pt',
    text: 'Type the address of its homepage in the field on the left, the way it appears in your browser: https://yourstore.com',
  },
  {
    kind: 'text',
    from: 'pt',
    text: 'No need for a page path or tracking parameters. yourstore.com works too, and https:// is added for you.',
  },
  {
    kind: 'text',
    from: 'pt',
    text: 'If your site lives on a subdomain, like shop.yourstore.com, enter that exactly. Each subdomain is its own website.',
  },
  {
    kind: 'text',
    from: 'pt',
    text: 'Start with one. Every plan includes unlimited websites, so you can add the rest later from Websites.',
  },
];

/** Played once, when the first website is saved. The date kind is the thread's section label. */
export const SNIPPET_TIPS: readonly ChatMessage[] = [
  { kind: 'date', label: 'Installing the snippet' },
  { kind: 'headline', text: 'Next, one line on your website.' },
  {
    kind: 'text',
    from: 'pt',
    text: 'Copy the snippet on the left and paste it into the HTML of every page you want to test, just before the closing </head> tag. On most sites that is one shared header or layout file.',
  },
  {
    kind: 'text',
    from: 'pt',
    text: 'Using Google Tag Manager? Create a Custom HTML tag, paste the snippet, set the trigger to All Pages, then publish the container.',
  },
  {
    kind: 'text',
    from: 'pt',
    text: 'On Shopify, WordPress or another CMS, look for a header code or theme head setting and paste it there.',
  },
  {
    kind: 'text',
    from: 'pt',
    text: 'We confirm the install when your first experiment runs, and a page cache can hold the old page for a few minutes.',
  },
  { kind: 'headline', text: 'No time right now?' },
  {
    kind: 'text',
    from: 'pt',
    text: 'Go to the dashboard and install it later. The snippet is always under Websites, and you can pass it to your developer from there.',
  },
];
